<template>
	<details v-if="visible">
		<summary>
			<component :is="componentOfPart(headerPart)" :part="partRef(headerPart)" :data="localData" :readonly="ro" :viewmode="vm"></component>
		</summary>
		<component :is="componentOfPart(bodyPart)" :part="partRef(bodyPart)" :data="localData" :readonly="ro" :viewmode="vm"></component>
	</details>
</template>

<script setup lang="ts">
import useContainer, {type ContainerProps, containerProps} from "./Container";
import type {Details} from "@t/fd/layout/Details";
import {EMPTY_PART} from "../ComponentResolver";
import {computed} from "vue";

const uprops = defineProps({...containerProps});
const props = uprops as ContainerProps;

const details = computed<Details>(() => props.part as Details);
const {visible, componentOfPart, partRef, localData, ro, vm} = useContainer(props);

const headerPart = computed(() => {
	return details.value.header || EMPTY_PART;
});
const bodyPart = computed(() => {
	return details.value.body || EMPTY_PART;
});

</script>

<style></style>
